import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslate} from 'react-redux-multilingual';
import {TbArrowLeft, TbArrowRight} from 'react-icons/tb';

// Top bar of the apartment picker (floor view and apartment view).
// Replaces three icon images that were hosted on a server that no longer responds.
function SelectionNav({backLabel, onBack}) {
    const t = useTranslate();
    return (
        <nav className="cpr-selection-nav" aria-label={t('select_apartment')}>
            <div className="cpr-container cpr-selection-nav__inner">
                <button type="button" className="cpr-selection-nav__back" onClick={onBack}>
                    <TbArrowLeft aria-hidden="true"/>
                    <span>{backLabel}</span>
                </button>
                <picture className="cpr-selection-nav__building" aria-hidden="true">
                    <source type="image/webp" srcSet="/assets/images/cpr/arabkir-cutout-768.webp"/>
                    <img src="/assets/images/building/building.png" alt="" width="1537" height="978"/>
                </picture>
                <Link to="/info" className="cpr-selection-nav__details">
                    <span>{t('details')}</span>
                    <TbArrowRight aria-hidden="true"/>
                </Link>
            </div>
        </nav>
    );
}

export default SelectionNav;
